import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useAuth } from 'src/hooks/useAuth/useAuth';

export const useSentryUser = (): void => {
  const { user } = useAuth();
  const { id, email, name, role } = user;

  useEffect(() => {
    Sentry.setUser(id ? { id, email, username: name, role } : null);
  }, [id, email, name, role]);
};
